import React from "react";
import * as Styles from "./CarDeliveryDealerResult.styles";
import { useUscLabel } from "../../../../utils/labels";
import Icon from "../../../../../shared-components/lexus/styles/atoms/Icon";

type CarDeliveryDealerResultProps = {
    name: string;
    address?: string;
    selectLocation: () => void;
    distance?: number;
};

const CarDeliveryDealerResult = ({
    name,
    address,
    selectLocation,
    distance,
}: CarDeliveryDealerResultProps): JSX.Element => {
    const distanceLabel = useUscLabel("uscCarDeliveryDealerResultDistance", {
        value: distance ? distance.toFixed(1) : "",
    });

    return (
        <Styles.DealerResultWrapper tabIndex={0} role="option" onClick={selectLocation}>
            <Icon variant="car" />
            <Styles.DealerResultEllipsis>
                {name}
                {!!address && `, ${address}`}
            </Styles.DealerResultEllipsis>
            {!!distance && (
                <Styles.DealerResultDistanceWrapper>
                    <Styles.DealerResultDistance>{distanceLabel}</Styles.DealerResultDistance>
                    <Icon variant="location" />
                </Styles.DealerResultDistanceWrapper>
            )}
        </Styles.DealerResultWrapper>
    );
};

export default CarDeliveryDealerResult;
